<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
        <b-col cols="12">
          <b-card no-body>
            <template v-slot:header>
              <span class="pull-left mt-2 mb-2"><strong>Account: {{item.name}}</strong></span>
            </template>
            <b-col cols="12" class="mt-2">
              <b-form-group label="Naam">
                <b-form-input type="text" required v-model="item.name" disabled></b-form-input>
              </b-form-group>
              <b-form-group label="E-mailadres">
                <b-form-input type="text" required v-model="item.email" disabled></b-form-input>
              </b-form-group>
              <b-form-group label="E-mail aanhef">
                <b-form-input type="text" required v-model="item.email_salutation" disabled></b-form-input>
              </b-form-group>
              <div v-if="item.account !== null" class="mb-3">
                <hr>
                Deze contactpersoon is gekoppeld aan account:<br>
                <strong class="hoverable" @click="$router.push({ name: 'accounts.view', params: { id: item.account.id } })">{{ item.account.name }} <br>Salesforce ID: {{item.account.sfId}}</strong>
              </div>
              <div v-if="item.account == null" class="mb-3">
                <hr>
                Deze contactpersoon is <strong>niet gekoppeld</strong> aan een <strong>Salesforce relatie</strong>. Dit betekent dat er geen data beschikbaar is in de portaal van de gebruiker.
              </div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {getData} from '../../api';

export default {
  name: 'contact',
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      contacts: [],
      editable: false,
      companyOptions: [],
      countryOptions: [],
      item: [],
      errors: null,
    }
  },
  methods: {
    async getItem() {
      const item = await getData('accounts/contacts/' + this.$route.params.id).then(response => response.data);
      this.item = item.data
    }
  },
  beforeMount() {
    this.getItem();
  },
}

</script>
